export const fieldHeight = '40px';

export const borderRadius = {
  desktop: 2,
  mobile: 4
};

export const cornerRadius = {
  default: 4,
  rounded: 999
};

export const headingFontSizes = {
  xsmall: {
    desktop: 1,
    mobile: 1
  },
  small: {
    desktop: 1.25,
    mobile: 1.1
  },
  normal: {
    desktop: 1.5,
    mobile: 1.25
  },
  large: {
    desktop: 2,
    mobile: 1.5
  }
};

export const textFontSizes = {
  xsmall: {
    desktop: 0.3,
    mobile: 0.1
  },
  small: {
    desktop: 0.85,
    mobile: 0.6
  },
  normal: {
    desktop: 1,
    mobile: 0.85
  },
  large: {
    desktop: 1.5,
    mobile: 1.5
  }
};

export const spacing = {
  spacing005: '4px',
  spacing01: '8px',
  spacing02: '16px',
  spacing03: '24px',
  spacing04: '32px',
  spacing05: '40px',
  spacing06: '56px'
};

export const elevation = {
  elevation1: '0 0 4px 0 rgba(0, 0, 0, 0.08), 0 7px 8px 0 rgba(0, 0, 0, 0.04)',
  elevation2: '0 -1px 4px 0 rgba(0, 0, 0, 0.10), 0 2px 16px 0 rgba(0, 0, 0, 0.10)'
};

export const cardShadowCss = hoverable => `
  box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.05),
    0 2px 16px 0 rgba(0, 0, 0, 0.10);

  ${
    hoverable
      ? `
    transition: all 0.15s ease;

    &:hover {
      box-shadow:
        0 1px 2px 0 rgba(0, 0, 0, 0.05),
        0 2px 32px 0 rgba(0, 0, 0, 0.20);
      transform: scale(1.01);
      z-index: 99;
    }

    .is-ie-11 &:hover, .is-edge &:hover {
      transform: scale3d(1.02, 1.02, 1)
    }
  `
      : ''
  }
`;

export const hintToolbarHeight = '4rem';
